export default __webpack_public_path__ + "static/forme-transversal-7d334bd92ef32c63ec51272df97ea232.png";